import * as React from 'react';

type Props = {
  name: string;
  onRemove?: () => void;
  showRemove?: boolean;
};

const TagDisplay = (props: Props) => (
  <span className="bg-muted-foreground text-background relative flex h-5 shrink-0 flex-row items-center overflow-hidden rounded-full px-2 text-xs">
    {props.name}
    {props.showRemove && (
      <button
        type="button"
        className="hover:bg-border absolute right-0 mr-0 ml-1 flex h-5 w-[22px] cursor-pointer items-center border-none bg-transparent pl-1 text-xl opacity-0 hover:opacity-100"
        onClick={() => props.onRemove && props.onRemove()}
      >
        ×
      </button>
    )}
  </span>
);

export {TagDisplay};
